export type AppConfig = Record<string, string>